import { datatypes, inputTypes } from "data/globalData";

export const buyingQtyColumns = {
	size: {
		name: "Size",
		key: "size",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.NUMBER.key,
		sort_no: 0,
	},
	region: {
		name: "Region",
		key: "region",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.NUMBER.key,
		sort_no: 0,
	},
	channel: {
		name: "Channel",
		key: "channel",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.NUMBER.key,
		sort_no: 0,
	},
	total_qty: {
		name: "Qty",
		key: "total_qty",
		input_type: inputTypes.AUTO_GENERATE.key,
		constraints: { NOTNULL: true, DISPLAY: false, UNIQUE: false },
		data: {},
		data_type: datatypes.NUMBER.key,
		sort_no: 0,
	},
};

export const generateBuyChannelRegionHistDataCacheKey = (data) => {
	return `BUY-SIZE-RATIO-HIST-${data?.brand}-${data?.sub_brand}-${data?.category}-${data?.sub_category}-${data?.color}-${data?.palette}`;
};
